import { createFileRoute } from "@tanstack/react-router";
import z from "zod";
import { WechatBindPage } from "@/features/auth/wechat-bind-page";

const searchSchema = z.object({
  token: z.string().min(1),
});

export const Route = createFileRoute("/auth/wechat-bind")({
  component: RouteComponent,
  validateSearch: searchSchema.parse,
  head: () => ({
    meta: [{ name: "robots", content: "noindex,nofollow" }],
  }),
});

function RouteComponent() {
  const { token } = Route.useSearch();

  return <WechatBindPage token={token} />;
}
